/**
 * @param {EmployeeBidProfile.IGroupedScheduleTemplateItems[]} items 
 * @param {string[]} selectedItemIds 
 * @param {boolean} isGroupShiftlinesWithSameSchedules
 */
export const getSelectedShiftlineCount = (items, selectedItemIds, isGroupShiftlinesWithSameSchedules) => items
    .filter((x) => selectedItemIds.includes((isGroupShiftlinesWithSameSchedules ? x.groupId : x.id.toString())))
    .reduce((total, item) => total + item.quantity, 0);
